import {skipToken} from "@reduxjs/toolkit/query";

import {isServer} from "../../app/read_rp_environment_variables";
import {useAppSelector} from "../../store/hooks";
import {useGetReservationAvailabilityQuery} from "../api/reservation_api";
import {selectReservedByMeUntil} from "../state/reservation_slice";
import {ReservationAvailabilityStatus} from "../types/ReservationAvailabilityStatus";

// seconds - matches how long the API itself caches availability
const AVAILABILITY_REFETCH_AFTER_S = 60;

export interface IUseReservationAvailabilityParams {
    propertyId: number | null | undefined;
    isEnabled: boolean;
}

export interface IReservationAvailability {
    // "taken" while the current user's own reservation of the property is fresh - the API may still report it as available
    status: ReservationAvailabilityStatus | undefined;
    // true with the own reservation as well, so a request in flight never shows a placeholder before "taken"
    hasData: boolean;
    isError: boolean;
}

// Client only - availability is never fetched during SSR, so it stays out of the initial state and the HTML cache
export const useReservationAvailability = (params: IUseReservationAvailabilityParams): IReservationAvailability => {
    const {propertyId, isEnabled} = params;
    const hasPropertyId = typeof propertyId === "number";
    const queryArgs = isEnabled && !isServer && hasPropertyId ? {propertyId} : skipToken;

    // currentData belongs to the current args only - a skipped query or another property never reuses older statuses
    const {currentData, isError} = useGetReservationAvailabilityQuery(queryArgs, {refetchOnMountOrArgChange: AVAILABILITY_REFETCH_AFTER_S});
    const reservedByMeUntil = useAppSelector((state) => (hasPropertyId ? selectReservedByMeUntil(propertyId)(state) : null));
    const isReservedByMe = reservedByMeUntil !== null && reservedByMeUntil > Date.now();

    return {
        status: isReservedByMe ? "taken" : hasPropertyId ? currentData?.[String(propertyId)] : undefined,
        hasData: isReservedByMe || currentData !== undefined,
        isError
    };
};
import {skipToken} from "@reduxjs/toolkit/query";

import {isServer} from "../../app/read_rp_environment_variables";
import {useAppSelector} from "../../store/hooks";
import {useGetReservationAvailabilityQuery} from "../api/reservation_api";
import {selectReservedByMeUntil} from "../state/reservation_slice";
import {ReservationAvailabilityStatus} from "../types/ReservationAvailabilityStatus";

// seconds - matches how long the API itself caches availability
const AVAILABILITY_REFETCH_AFTER_S = 60;

export interface IUseReservationAvailabilityParams {
    propertyId: number | null | undefined;
    isEnabled: boolean;
}

export interface IReservationAvailability {
    // "taken" while the current user's own reservation of the property is fresh - the API may still report it as available
    status: ReservationAvailabilityStatus | undefined;
    // true with the own reservation as well, so a request in flight never shows a placeholder before "taken"
    hasData: boolean;
    isError: boolean;
}

// Client only - availability is never fetched during SSR, so it stays out of the initial state and the HTML cache
export const useReservationAvailability = (params: IUseReservationAvailabilityParams): IReservationAvailability => {
    const {propertyId, isEnabled} = params;
    const hasPropertyId = typeof propertyId === "number";
    const queryArgs = isEnabled && !isServer && hasPropertyId ? {propertyId} : skipToken;

    // currentData belongs to the current args only - a skipped query or another property never reuses older statuses
    const {currentData, isError} = useGetReservationAvailabilityQuery(queryArgs, {refetchOnMountOrArgChange: AVAILABILITY_REFETCH_AFTER_S});
    const reservedByMeUntil = useAppSelector((state) => (hasPropertyId ? selectReservedByMeUntil(propertyId)(state) : null));
    const isReservedByMe = reservedByMeUntil !== null && reservedByMeUntil > Date.now();

    return {
        status: isReservedByMe ? "taken" : hasPropertyId ? currentData?.[String(propertyId)] : undefined,
        hasData: isReservedByMe || currentData !== undefined,
        isError
    };
};
